/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for constructing a payment destination for a progression.
 *
 * ``conversation_id`` is optional: when present it is carried back through the Stripe
 * redirect so the FE can reopen the originating conversation; when absent the redirect
 * simply omits it.
 */
export interface PaymentDestinationRequest {
  /** Conversation to return the user to after checkout, if any. */
  conversation_id?: string | null;
}
